import { useCallback } from 'react';

import { useNotify, useTranslate } from 'react-admin';

import BackendData, { NodeValidationError } from './prepareBackendData';

import type { FlowChartData, DialplanDataBase } from './types';

const useBackendData: () => (
  flowChartData: FlowChartData,
  resource?: string,
  shouldRegenerateIds?: boolean,
  onNodeError?: (nodeId: string) => void
) => DialplanDataBase | false = () => {
  const notify = useNotify();
  const translate = useTranslate();
  return useCallback(
    (
      flowChartData: FlowChartData,
      resource = 'callflows',
      shouldRegenerateIds,
      onNodeError
    ): DialplanDataBase | false => {
      const backendData: BackendData = new BackendData(flowChartData);
      try {
        if (shouldRegenerateIds === true) {
          backendData.regenerateNodeIds();
        }
        const data: DialplanDataBase = backendData.prepare(resource);
        return data;
      } catch (error) {
        if (error instanceof NodeValidationError) {
          onNodeError?.(error.nodeId);
        }
        if (error instanceof Error) {
          notify('callflows.notifications.callflowDataError', {
            type: 'error',
            messageArgs: { error: translate(error.message) },
          });
        }
        return false;
      }
    },
    [notify, translate]
  );
};

export default useBackendData;
